import React, { useContext } from "react";
import dynamic from "next/dynamic";
// const CardRow = dynamic(() => import("components/card/CardRow"));
import CardRow from "components/card/CardRow";
// const ExperienceCard = dynamic(() =>
//   import("../ExperienceCard/ExperienceCard")
// );
// const LinkCard = dynamic(() => import("components/card/LinkCard"));
const ExperienceLinkCard = dynamic(
  () =>
    import(
      "components/ExperiencePresentation/ExperienceCard/ExperienceLinkCard"
    )
);
// const LocationTag = dynamic(() => import("components/ui/Tag/LocationTag"));

import { CurrencyContext } from "contexts/currency";

const RelatedExperiences = React.forwardRef((props, ref) => {
  const {
    experiences,
    title,
    sideScroll,
    cardRowRef,
    titleType,
    sideScrollButtons = true,
    scrollIndicator = true,
    scrollAfterCardsCount = 3,
  } = props;

  const currencyContext = useContext(CurrencyContext);
  const currency = currencyContext.currency ?? {
    fullName: "United States Dollar",
    code: "usd",
    symbolCode: 36,
    symbol: "$",
  };

  // const relatedExperiences = experiences.map((experience, index) => {
  //   return (
  //     <ExperienceCard key={index} experience={experience} currency={currency} />
  //   );
  // });

  const relatedExperiences = experiences?.map((item, index) => {
    return (
      <ExperienceLinkCard
        experience={item}
        currency={currency}
        key={index}
        headerFontSize="var(--font-size-md)"
        cardProps={{
          sizes: `
            (min-width: 320px) 320px,
            320px`,
        }}
      />
    );
  });

  return (
    <>
      <CardRow
        cards={relatedExperiences}
        seeAll={false}
        sideScroll={sideScroll}
        sideScrollButtons={sideScrollButtons}
        scrollIndicator={scrollIndicator}
        ref={cardRowRef}
        sectionTitle={title ?? ""}
        scrollAfterCardsCount={scrollAfterCardsCount}
      />
      {/* <h2>Related Experiences</h2> */}
      {/* </CardRow> */}
    </>
  );
});

RelatedExperiences.displayName = "RelatedExperiences";
export default RelatedExperiences;
